import React, { memo } from 'react';

import { Box, Button } from '@mui/material';
import { AddBoxIcon, DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { buttonsWrapperStyles } from './ControlsSection.styles';
import { ControlsSectionTestIds } from './ControlsSection.testIds';

const ControlsSection = ({
  disabled,
  isBplLoanPurposeType,
  isTrustSectionVisible,
  onTitleHolderAdd,
  onToggleTrust,
}) => (
  <>
    {!isBplLoanPurposeType && (
      <Box display="flex" sx={buttonsWrapperStyles}>
        <Button
          data-testid={ControlsSectionTestIds.TOGGLE_TRUST_BUTTON}
          disabled={disabled}
          startIcon={isTrustSectionVisible ? <DeleteIcon /> : <AddBoxIcon />}
          onClick={onToggleTrust}
        >
          {`${isTrustSectionVisible ? 'Remove' : 'Add'} Trust`}
        </Button>

        <Button
          data-is-add-button="true"
          data-testid={ControlsSectionTestIds.ADD_TITLE_HOLDER_BUTTON}
          disabled={disabled}
          startIcon={<AddBoxIcon />}
          onClick={onTitleHolderAdd}
        >
          Add More Title Holders
        </Button>
      </Box>
    )}
  </>
);

ControlsSection.propTypes = {
  onTitleHolderAdd: PropTypes.func.isRequired,
  onToggleTrust: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isBplLoanPurposeType: PropTypes.bool,
  isTrustSectionVisible: PropTypes.bool,
};

export default memo(ControlsSection);
